const ResetPasswordPage = () => {
  return <h1>reset password page</h1>;
};

export { ResetPasswordPage };
